import React, { Component } from 'react';
import LiveLocationMarkerView from './live-location-marker-view';
import { setCurrentDriverCardOnMap } from '../available-drivers-map/available-drivers-map-actions';
import { connect } from 'react-redux';

class LiveLocationMarker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    }
  }

  mouseEnter = () => this.setState({hovered: true});
  mouseLeave = () => this.setState({hovered: false});

  render() {
    return (
      <LiveLocationMarkerView
        {...this.props}
        mouseEnter={this.mouseEnter}
        mouseLeave={this.mouseLeave}
        hovered={this.state.hovered}
        expanded={this.props.availableDriversMap.currentDriver && this.props.availableDriversMap.currentDriver.driverId === this.props.driver.driverId}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  availableDriversMap: state.availableDriversMap
});

const mapDispatchToProps = {
  setCurrentDriverCardOnMap: setCurrentDriverCardOnMap
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveLocationMarker);



// WEBPACK FOOTER //
// ./src/components/map-markers/live-location-marker.js